import type { CSSProperties } from 'react';
import { useClickSound } from '../hooks/useClickSound';

interface EventsButtonProps {
  onOpen: () => void;
}

export default function EventsButton({ onOpen }: EventsButtonProps) {
  const { withClickSound } = useClickSound();

  const buttonStyle: CSSProperties = {
    padding: '10px 14px',
    borderRadius: '12px',
    background: 'rgba(255, 255, 255, 0.06)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    fontWeight: 600,
    transition: 'all 0.2s ease',
  };

  return (
    <button
      onClick={withClickSound(onOpen)}
      style={buttonStyle}
      type="button"
    >
      <svg
        style={{ width: '16px', height: '16px' }}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      </svg>
      <span>Events</span>
    </button>
  );
}
